<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 48 48`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      :id="iconName"
      lang="en">
      {{ iconName }} icon
    </title>
    <g
      :fill="fillColor"
      :stroke="strokeColor">

  <g :transform="`translate(${2*pxw},0)`">
    <rect :x="2*pxw" :y="h-pxh" :width="pxw" :height="pxh" :fill="nutColDk"/>

    <rect :x="1*pxw" :y="h-(2*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="2*pxw" :y="h-(2*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="3*pxw" :y="h-(2*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>

    <rect :x="0*pxw" :y="h-(3*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="1*pxw" :y="h-(3*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="2*pxw" :y="h-(3*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="3*pxw" :y="h-(3*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="4*pxw" :y="h-(3*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>

    <rect :x="0*pxw" :y="h-(4*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="1*pxw" :y="h-(4*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="2*pxw" :y="h-(4*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="3*pxw" :y="h-(4*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="4*pxw" :y="h-(4*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>

    <rect :x="0*pxw" :y="h-(5*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="1*pxw" :y="h-(5*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="2*pxw" :y="h-(5*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="3*pxw" :y="h-(5*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="4*pxw" :y="h-(5*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>

    <rect :x="0*pxw" :y="h-(6*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="1*pxw" :y="h-(6*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="2*pxw" :y="h-(6*pxh)" :width="pxw" :height="pxh" :fill="nutColLt"/>
    <rect :x="3*pxw" :y="h-(6*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>
    <rect :x="4*pxw" :y="h-(6*pxh)" :width="pxw" :height="pxh" :fill="nutColDk"/>

	</g>
  <g :transform="`translate(${1*pxw},${h-(7*pxh)})`">

    <rect :x="0*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="1*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="2*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="3*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="4*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="5*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="6*pxw" :y="0" :width="pxw" :height="pxh" :fill="capColDk"/>

    <rect :x="0*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="1*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="2*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="3*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="4*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="5*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="6*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>

    <rect :x="1*pxw" :y="-2*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="2*pxw" :y="-2*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="3*pxw" :y="-2*pxh" :width="pxw" :height="pxh" :fill="capColLt"/>
    <rect :x="4*pxw" :y="-2*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="5*pxw" :y="-2*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>

    <rect :x="3*pxw" :y="-3*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="3*pxw" :y="-4*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>
    <rect :x="4*pxw" :y="-4*pxh" :width="pxw" :height="pxh" :fill="capColDk"/>

  </g>
  <g :transform="`translate(0,${h-(10*pxh)})`">

    <rect :x="1*pxw" :y="0*pxh" :width="pxw" :height="pxh" :fill="leafColLt"/>
    <rect :x="2*pxw" :y="0*pxh" :width="pxw" :height="pxh" :fill="leafColLt"/>
    <rect :x="3*pxw" :y="0*pxh" :width="pxw" :height="pxh" :fill="leafColDk"/>

    <rect :x="0*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="leafColLt"/>
    <rect :x="1*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="leafColLt"/>
    <rect :x="2*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="leafColLt"/>
    <rect :x="3*pxw" :y="-1*pxh" :width="pxw" :height="pxh" :fill="leafColDk"/>

  </g>

    </g>
  </svg>
</template>

<script>
export default {
  name: 'Acorn',
  props: {
    iconName: {
      type: String,
      default: 'Acorn'
    },
    width: {
      type: [Number, String],
      default: 48
    },
    height: {
      type: [Number, String],
      default: 48
    },
    strokeColor: {
      type: String,
      default: 'none'
    },
    fillColor: {
      type: String,
      default: 'lightgray'
    }
  },
  data() {
    return {
      nutColLt: '#fbac34',
      nutColDk: '#e88e3d',
      capColLt: '#b1795b',
      capColDk: '#9b6950',
      leafColLt: '#a2aa76',
      leafColDk: '#8ba597',
      pxw: 5,
      pxh: 4,
      w: 48,
      h: 48,
    };
  },
  components: {},
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.svg-icon  {}
</style>
